module.exports = __webpack_public_path__ + "static/media/why-it-works.7bc794ff.svg";